module.exports = fox => {
    'use strict';

    const require__template = require.context('fox-dynamic-injection!fox-template-loader!./templates', true, /\.tpl$/);
    const require__js = require.context('./widget', true, /\.js$/);

    require('../../../../../model/promo2/components/login-wizard')(fox);

    require__template.keys().forEach(_module => require__template(_module)(fox));
    require__js.keys().forEach(_module => require__js(_module)(fox, fox.jQuery));
}


// WEBPACK FOOTER //
// ./components/login-wizard/index.es.js